import { Link } from "react-router-dom";

export default function EcoFlowHero() {
  const scrollToForm = () => {
    document.getElementById("ecoflow-signup")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden bg-gray-950">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/212f1b9f3861af6a226dc701f96dc9d5.jpg"
          alt="EcoFlow DELTA Pro portable power station — coming soon to Iron Haven Supply"
          className="w-full h-full object-cover object-center opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950 via-gray-950/85 to-gray-950/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-transparent to-gray-950/30" />
      </div>

      {/* Amber glow accent */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(ellipse at 70% 50%, rgba(245,158,11,0.12) 0%, transparent 60%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-24 w-full">
        <div className="max-w-2xl">
          {/* Status badge */}
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex items-center gap-1.5 bg-amber-500/20 border border-amber-500/40 text-amber-400 text-xs font-bold px-3 py-1.5 rounded-full">
              <span className="w-1.5 h-1.5 bg-amber-400 rounded-full animate-pulse inline-block"></span>
              Coming Soon
            </span>
            <span className="text-gray-500 text-xs font-medium">Authorized Reseller Onboarding in Progress</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight leading-[1.05] mb-5">
            EcoFlow is Coming to<br />
            <span className="text-amber-400">Iron Haven Supply</span>
          </h1>

          <p className="text-gray-300 text-lg leading-relaxed mb-8 max-w-xl">
            We&apos;re finalizing our authorized dealer agreement with EcoFlow — makers of the world&apos;s most advanced portable power stations and home energy systems. Be first in line for launch pricing.
          </p>

          {/* Product family chips */}
          <div className="flex flex-wrap gap-2 mb-10">
            {[
              { label: "DELTA Series", sub: "Up to 25kWh" },
              { label: "RIVER Series", sub: "Compact & portable" },
              { label: "Smart Home Panel", sub: "10 circuits" },
              { label: "Solar Panels", sub: "220W–400W" },
              { label: "PowerStream", sub: "Microinverter" },
            ].map((chip) => (
              <div
                key={chip.label}
                className="flex items-center gap-1.5 bg-white/8 border border-white/12 rounded-full px-3.5 py-1.5"
              >
                <span className="text-white text-xs font-semibold">{chip.label}</span>
                <span className="text-gray-500 text-xs">· {chip.sub}</span>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={scrollToForm}
              className="flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-white font-bold text-sm px-7 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-bell-line text-sm"></i>
              </div>
              Get Early Access
            </button>
            <a
              href="#products"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("products")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/15 border border-white/15 text-white font-semibold text-sm px-7 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-line text-sm"></i>
              </div>
              Preview Products
            </a>
          </div>

          {/* Trust note */}
          <div className="flex items-center gap-4 mt-8 flex-wrap">
            {[
              { icon: "ri-shield-check-line", text: "Authorized dealer pricing" },
              { icon: "ri-lock-2-line", text: "No spam, ever" },
              { icon: "ri-award-line", text: "Manufacturer warranty honored" },
            ].map((t) => (
              <div key={t.text} className="flex items-center gap-1.5 text-gray-500 text-xs">
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className={`${t.icon} text-amber-500 text-xs`}></i>
                </div>
                {t.text}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 text-gray-600">
        <span className="text-[10px] uppercase tracking-widest font-medium">Scroll to explore</span>
        <div className="w-4 h-4 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-line text-sm"></i>
        </div>
      </div>
    </section>
  );
}
